import {AkCopyIcon, AkEditIcon, AkTrashIcon} from '@fuegokit/fuegoicons-react'
import React from 'react'
import styled from 'styled-components'
import {Box, SxProp, sx, themeGet, AtlasButtonGroup, AtlasButton, VisuallyHidden} from '../..'
import {TestIdType} from './types'
import Placeholder from '../../components/Placeholder'

// ------------------------------
/** * Wrapper component for actions in a collapse or footer menu */
type RuleItemUserActionsType = React.PropsWithChildren<{}>
export type RuleItemUserActionsProps = RuleItemUserActionsType & TestIdType & SxProp

const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid;
  border-top-color: ${themeGet('colors.border.default')};
  margin-top: ${themeGet('space.2')};
  padding-top: ${themeGet('space.2')};
  width: 100%;
  ${sx}
`

// this is just a placeholder
const RuleItemUserActions = ({children, testId, ...props}: RuleItemUserActionsProps) => {
  return (
    <Wrapper>
      <Box sx={{marginRight: 'auto', display: 'flex', width: '254px'}}>
        {/** @TODO: Add an avatar and a relative time component */}
        <Placeholder height="44px" label="Avatar + relative time component" />
      </Box>

      <Box
        sx={{
          marginLeft: 'auto',
          display: 'flex',
          width: '254px',
          alignItems: 'center',
          justifyContent: 'flex-end'
        }}
      >
        <AtlasButtonGroup appearance="subtle" sx={{color: 'red'}}>
          <AtlasButton leadingIcon={AkEditIcon}>
            <VisuallyHidden>Edit</VisuallyHidden>
          </AtlasButton>
          <AtlasButton leadingIcon={AkCopyIcon}>
            <VisuallyHidden>Edit</VisuallyHidden>
          </AtlasButton>
          <AtlasButton leadingIcon={AkTrashIcon}>
            <VisuallyHidden>Delete</VisuallyHidden>
          </AtlasButton>
        </AtlasButtonGroup>
      </Box>
      {children}
    </Wrapper>
  )
}

RuleItemUserActions.displayName = 'RuleItemUserActions'
export default RuleItemUserActions
